// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"270":"03887d60","291":"36b2b192","479":"a6908656","489":"9c143e9f","512":"6fa72f6c","924":"50247b1e"}[chunkId] + ".css";
};